import request from '@/router/axios'
import env from '@/config/env'

/**
 * 获取订单详情
 */
export const getOrder = (orderNo) => {
  return request({
    url: env.ferryUrl + '/orderAdmin/getInfoByNo',
    method: 'GET',
    params: {
      orderNo: orderNo
    }
  })
}

/**
 * 订单列表
 * @param params
 */
export const getPage = (params) => {
  return request({
    url: env.ferryUrl + '/orderAdmin/pageNew',
    method: 'post',
    data: params
  })
}

/**
 * 获取派单司机信息
 * @param params
 */
export const getDriverByOrderNo = (params) => {
  return request({
    url: env.ferryUrl + '/orderAdmin/operation/driverInfoByNo',
    method: 'get',
    params: params
  })
}

/**
 * 获取服务中的司机
 * @param orderId
 */
export const getServiceDriver = (orderId) => {
  return request({
    url: env.ferryUrl + `/orderAdmin/getServeringDriverByOrderId?orderId=${orderId}`,
    method: 'get'
  })
}
/**
 * 获取退款金额
 * @param orderId
 */
export const gettkAmount = (orderId) => {
  return request({
    url: env.ferryUrl + `/orderAdmin/getCanRefundAmount?orderId=${orderId}`,
    method: 'get'
  })
}

/**
 * 退款
 * @param data
 */
export const refund = (data) => {
  return request({
    url: env.ferryUrl + '/orderAdmin/orderRefundAdmin',
    method: 'POST',
    data: data
  })
}

/**
 *  派单
 * @param data
 */
export const sendOrder = (data) => {
  return request({
    url: env.ferryUrl + '/orderAdmin/operationOrder',
    method: 'POST',
    data: data
  })
}


/**
 *  获取当前登录用户所属供应商及下属供应商
 */
export const getIntercityMerchantList = () => {
  return request({
    url: env.ferryUrl + '/orderAdmin/getIntercityMerchantList',
    method: 'GET'
  })
}

/**
 *  获取接单(摆渡)供应商信息
 */
export const getFerryMerchantList = () => {
  return request({
    url: env.ferryUrl + '/orderAdmin/getFerryMerchantList',
    method: 'GET'
  })
}
/**
 *  获取线路信息
 */
export const getLineList = () => {
  return request({
    url: env.ferryUrl + '/orderAdmin/getLineList',
    method: 'GET'
  })
}
/**
 *  根据线路id获取班次时间
 */
export const getFlightPlanTimeList = (id) => {
  return request({
    url: env.ferryUrl + `/orderAdmin/getFlightPlanTimeList?lineId=${id}`,
    method: 'GET',

  })
}
/**
 *  根据摆渡供应商信息获取司机信息
 */
export const getDriverInfoList = (id) => {
  return request({
    url: env.ferryUrl + `/orderAdmin/getDriverInfoList?ferryMerchantId=${id}`,
    method: 'GET',
  })
}

/**
 *  获取站点信息
 */
export const getStationInfoList = () => {
  return request({
    url: env.ferryUrl + '/orderAdmin/getStationInfoList',
    method: 'GET'
  })
}

export const refundDetails = (orderId) => {
  return request({
    url: env.ferryUrl + '/c-order/refundDetail',
    method: 'get',
    params: {
      orderId: orderId
    }
  })
}

